import { updateSubscriptionContract } from "../mutations/updateSubscriptionContract.subscriptions.js";
import Logger from "@cappelendamm/logger";
import { getSubscriptionContract } from "../queries/getSubscriptionContract.core.js";
export const updateRenewAt = async ({ contractId, renewAt }, { client }) => {
    Logger.log(`Updating subscription contract renewAt to ${renewAt} for contract ${contractId}...`);
    const contract = await getSubscriptionContract({ contractId }, { client });
    const statusUpdate = {
        price: contract.status?.phase?.price,
        currency: contract.status?.phase?.currency,
        renewAt,
        activeUntil: renewAt,
    };
    const updatedId = await updateSubscriptionContract({
        id: contractId,
        status: statusUpdate,
    }, { client });
    if (updatedId) {
        Logger.log(`Successfully updated renewAt and activeUntil for contract ${contractId} from ${contract.status.renewAt} to ${renewAt}`);
    }
    return updatedId;
};
